import type { ReactElement } from 'react';

import { L12nText } from '../../../../../text/L12nText';

import styles from './SweetBonanzaTableResult.module.css';

interface SweetBonanzaResultProps {
  additional: {
    bubbleSurprise: string;
    gr: string;
    payout: string;
    rc: string;
    sbBooster: string;
    sugarBomb: string;
    sugarBombBet: string;
    multipliers: string[];
    totalAnteMultiplier: string;
    totalMultiplier: string;
  };
}

export default function SweetBonanzaTableResult({ additional }: SweetBonanzaResultProps): ReactElement {
  return (
    <div className={styles.SweetBonanzaTableResult}>
      {additional.sugarBomb === 'true' && (
        <>
          <div>
            <L12nText tk="SUGAR_BOMB_DETAILS" />
          </div>
          {(Array.isArray(additional.multipliers) ? additional.multipliers : [additional.multipliers]).map(
            (sbMul: string, index: number) => (
              <div key={index}>
                #{index + 1} - {parseInt(sbMul)}x
              </div>
            )
          )}
          <div>
            <L12nText tk="TOTAL_MULTIPLIER" /> {additional.totalMultiplier}x
          </div>
          {additional.sugarBombBet === 'true' && (
            <div>
              <L12nText tk="SUGAR_BOMB_BOOSTER" /> {additional.sbBooster}x
            </div>
          )}
          {additional.sugarBombBet === 'true' && (
            <div>
              <L12nText tk="BOOSTED_TOTAL_MULT" /> {additional.totalAnteMultiplier}x
            </div>
          )}
          {additional.sugarBombBet === 'false' && (
            <div>
              <L12nText tk="SBB_WAS_DISABLED" />
            </div>
          )}
        </>
      )}

      {additional.gr === 'Bubble Surprise' && (
        <>
          {additional.rc === '4' && Number(additional.payout) == 5 && (
            <div>
              <L12nText tk="BUBBLE_SURPRISE" />: <L12nText tk="BLUE_CANDY" />
            </div>
          )}
          {additional.rc === '4' && Number(additional.payout) == 10 && (
            <div>
              <L12nText tk="BUBBLE_SURPRISE" />: <L12nText tk="PURPLE_CANDY" />
            </div>
          )}
          {additional.rc === '4' && Number(additional.payout) == 25 && (
            <div>
              <L12nText tk="BUBBLE_SURPRISE" />: <L12nText tk="RED_CANDY" />
            </div>
          )}
          {additional.rc === '5' && (
            <div>
              <L12nText tk="BUBBLE_SURPRISE" />: <L12nText tk="SWEET_SPINS_SMALL" />
            </div>
          )}
          {additional.rc === '6' && (
            <div>
              <L12nText tk="BUBBLE_SURPRISE" />: <L12nText tk="CANDY_DROP" />
            </div>
          )}
        </>
      )}
    </div>
  );
}
